export const APP_ROUTES = {
  home: '/',
  login: '/login',
  chat: '/chat',
  auth: {
    postSignin: '/auth/post-signin',
  },
  pricing: '/pricing',
  acceptInvitation: '/accept-invitation',
  checkout: '/checkout',
  checkoutPlan: '/checkout/$planId',
  dashboard: {
    root: '/dashboard',
    home: '/dashboard/home',
    team: '/dashboard/team',
    subscription: '/dashboard/subscription',
    plans: '/dashboard/plans',
    settings: '/dashboard/settings',
  },
  legacy: {
    settings: '/settings',
  },
} as const

export function toAppUrl(path: string, baseUrl: string) {
  return new URL(path, baseUrl).toString()
}
